import app from '@/app';
import angular from 'angular';

/* @ngInject */
function stateHandler(
	$transitions,
	$rootScope,
	$translate,
	JhiLanguageService,
	Auth,
	Principal,
	VERSION
) {
	return {
		initialize: () => {
			$rootScope.VERSION = VERSION;
			$rootScope.isTransitioning = false;
			$rootScope.isLoadingResults = false;

			$transitions.onStart({}, trans => {
				$rootScope.toState = trans.to();
				$rootScope.fromState = trans.from();
				// Blocks the screen during navigation (includes the entity/allMetrics
				// resolve and pagination reloads), giving feedback on heavy screens
				// such as the Result of large plans.
				$rootScope.isTransitioning = true;
				// Hygiene: clears any flag left stuck from a previous search.
				$rootScope.isLoadingResults = false;

				if (Principal.isAuthenticated()) {
					Auth.authorize();
				}

				JhiLanguageService.getCurrent().then(language => $translate.use(language));
			});

			const clearTransitioning = () => {
				$rootScope.isTransitioning = false;
			};
			$transitions.onSuccess({}, clearTransitioning);
			$transitions.onError({}, clearTransitioning);
		}
	};
}

app.factory('stateHandler', stateHandler);
